import React ,{Component, useState} from 'react';
import {Route, Redirect, Switch} from 'react-router-dom';
import NavIgationHeader from './NavigationHeader/NavIgationHeader'
import PersonalDetails from './MainContentArea/PersonalDetails'
import InvalidPath from './NotFound'
import Experiencecomponent  from './MainContentArea/ExperienceComponent';
import TechSkillCompo from './MainContentArea/TechSkill.js'
import PersonalComponent from './MainContentArea/PersonalComponent';
import './App.css';
import { setNestedObjectValues } from 'formik';
const Skills = [
  {Skill:"C#",ExperienceInyear: 6,proficiency:8 , LastTimeUsed:2021},
  {Skill:"Asp.Net Web Forms",ExperienceInyear: 2,proficiency:8 , LastTimeUsed:2021},
  {Skill:"Asp.Net MVC 3,5",ExperienceInyear: 3,proficiency:8 , LastTimeUsed:2019},
  {Skill:".Net Core",ExperienceInyear: 2,proficiency:8 , LastTimeUsed:2020},
  {Skill:".Net core Razor pages",ExperienceInyear: 0.8,proficiency:7 , LastTimeUsed:2020},      
  {Skill:".Net core Blazor",ExperienceInyear: 0.6,proficiency:8 , LastTimeUsed:2021},
  {Skill:"ADO.Net",ExperienceInyear: 4,proficiency:8 , LastTimeUsed:2021},
  {Skill:"Web Api",ExperienceInyear: 3,proficiency:8 , LastTimeUsed:2020},
  {Skill:"Entity Framework",ExperienceInyear: 3,proficiency:8 , LastTimeUsed:2020},
  {Skill:"SQL",ExperienceInyear: 3,proficiency:8 , LastTimeUsed:2020},
  {Skill:"Classic Asp",ExperienceInyear: 3,proficiency:8 , LastTimeUsed:2020},      
  {Skill:"Angular",ExperienceInyear: 2.8,proficiency:8 , LastTimeUsed:2020},
  {Skill:"Java Script/Jquery",ExperienceInyear: 2,proficiency:8 , LastTimeUsed:2017},
  {Skill:"Angular Material",ExperienceInyear: 0.6,proficiency:8 , LastTimeUsed:2020},
  {Skill:"Bootstarp",ExperienceInyear: 3,proficiency:8 , LastTimeUsed:2020},
  {Skill:"React",ExperienceInyear: 0.8,proficiency:7 , LastTimeUsed:2021},      
];
const authentication={
  isLoggedIn:false,  
  onAuthentication(){
    this.isLoggedIn=true    
    },
  getLogInStatus(){
    return this.isLoggedIn;
  }
}
function SecuredRoute(props){
  return(
    <Route path={props.path} render={data=>authentication.getLogInStatus()?(
      <props.component {...data}></props.component>):
      (<Redirect to={{pathname:'/Login'}}></Redirect>)}></Route>
  )
}
function Login(props){
    const [loginData,setloginData]=useState({username:'',Password:''})
    function changeLogInData(e){
      setloginData({...loginData,[e.target.name]:e.target.value});
      }    
      function onLogIn(){
        // debugger;
        // fetch("https://localhost:44306/api/Test",{
        //   method:'POST',
        //   headers:{'Content-type':'application/json'},
        //   body:JSON.stringify(loginData)
        // }).then(r=>r.json()).then(result=>{
        //   if(result){
        //     props.history.push('/home');
        //   }
        //   else{
        //     alert('Invalid UserName or PassWord');
        //   }
        // });
        if(loginData.username.toLowerCase() === "test" && loginData.password === "Password1"){
          authentication.onAuthentication(); 
          props.history.push('/Personal');
        }
        else{
          alert('Invalid UserName or PassWord');
        }      
      }  
     function ChnageMenu(){
        props.handleLogin(false)
     }
      return(
        <div className="Login-Row">        
          <div className="Form-Row">
            <h2 style={{textAlign:'center'}}>LogIn</h2><br/>
            {/* <label>UserName <input type="text" value={loginData.username} 
                               onChange={changeLogInData}></input></label><br/>
          
            <label>PassWord <input type="text" value={loginData.password} 
                              name="password" onChange={changeLogInData}></input></label><br/> */}
             <form> 
              <div className="form-outline mb-4">
              <label className="form-label" for="form1Example1">Email address</label>
                <input type="text" id="form1Example1"  name="username" onChange={changeLogInData} class="form-control" value={loginData.username} />                
              </div>
              <div className="form-outline mb-4">
                <label className="form-label" for="form1Example2">Password</label>
                <input type="password" id="form1Example2" className="form-control" value={loginData.password} 
                                          name="password" onChange={changeLogInData} />                
              </div>
              <div className="row mb-4">
                        <div className="col d-flex justify-content-center">    
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            value=""
                            id="form1Example3"                  
                          />
                        <label className="form-check-label" for="form1Example3"> Remember me </label>
                      </div>
                      </div>
                      <div className="col">      
                        <a href="#!">Forgot password?</a>
                      </div>
              </div>
              <button type="submit" className="btn btn-primary btn-block" onClick={()=> {ChnageMenu();onLogIn()}}>Sign in</button>
              </form>       
            </div>
        </div>
      )
}
class LogOut extends Component{
  constructor(props) {
    super(props)
  
    this.state = {
    }        
  }
    // props.handleLogin(false)
    // authentication.isLoggedIn=false;
    // props.history.push('/');
}
class  App extends Component{  
  constructor(props) {
    super(props)
  
    this.state = {
       MenuIndicator:true
    }
  }  
  handleMenu=(e)=>{
    this.setState({
      MenuIndicator:e
    })
  }
  render(){
    return (
      <>
      <div  className="HeaderDiv">   
         <NavIgationHeader MenuItem={this.state.MenuIndicator}></NavIgationHeader>
      </div>   
       <Switch>
       <Route exact path="/" component={PersonalDetails} ></Route>
       <Route path="/Experience" component={() => <Experiencecomponent Jobcomp="DATAINC"></Experiencecomponent> } ></Route>
       <Route path="/TechSkill" component={() => <TechSkillCompo skillList={Skills}></TechSkillCompo>}></Route>
       {/* <Route path="/Personal" component={PersonalComponent}></Route>  */}
       <SecuredRoute path="/Personal" component={PersonalComponent}></SecuredRoute>
       <Route path="/Login" render={(props) => <Login {...props} handleLogin={this.handleMenu}></Login>} ></Route>
       <Route path="/Logout" render={(props) => <LogOut {...props} handleLogin={this.handleMenu}></LogOut>} ></Route>
       <Route component={InvalidPath}></Route>
       </Switch>      
      </>
     );
  }
}

export default App
